import api from '../services/api';

const ClienteModel = {
    // Obtener todos los clientes
    getAll: async () => {
        try {
            const response = await api.get('/clientes');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo clientes:', error);
            return [];
        }
    },

    // Obtener clientes para newsletter
    getNewsletter: async () => {
        try {
            const response = await api.get('/clientes?newsletter=true');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo clientes newsletter:', error);
            return [];
        }
    },

    // Obtener estadísticas de clientes
    getStats: async () => {
        try {
            const response = await api.get('/clientes/stats');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo estadísticas:', error);
            return {
                total: 0,
                nuevos: 0,
                activos: 0
            };
        }
    }
};

export default ClienteModel;